export const saveRedirectUrl = (url) => {
  sessionStorage.setItem("redirectUrl", url);
};

export const getRedirectUrl = () => {
  return sessionStorage.getItem("redirectUrl") || "/";
};

export const clearRedirectUrl = () => {
  sessionStorage.removeItem("redirectUrl");
};
